import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import {
  loginPasswordSet,
  loginPasswordSetvalidationMessage,
  loginPasswordSetVisualization,
  loginPasswordFocus, loginPasswordBlur
} from 'src/app/redux/actions/login/loginPassword';
import { loginSetApiError } from 'src/app/redux/actions/login/login';
import PasswordMask from 'src/app/components/PasswordMask';
import FormControl from 'src/app/components/FormControl/FormControl';


class LoginFormPasswordContainer extends React.Component {

  onChange = ({ target }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;

    dispatch(loginPasswordSet(target.value));

    if (markedAsWrong || apiError) {
      dispatch(loginPasswordSetVisualization(!!target.validationMessage));
      dispatch(loginSetApiError(false));
    }
  };

  onBlur = ({ target }) => {
    const { dispatch, markedAsWrong } = this.props;
    const { validationMessage } = target;

    dispatch(loginPasswordBlur(markedAsWrong, validationMessage));
    dispatch(loginPasswordSetvalidationMessage(validationMessage));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(loginPasswordFocus());
  };


  render() {
    const { value, validationMessage, markedAsWrong, apiError, focus, disabled, inputRef } = this.props;
    const { onChange, onBlur, onFocus } = this;

    return (
      <FormControl {
                     ...{
                       validationMessage,
                       markedAsWrong,
                       apiError,
                       value,
                       focus,
                       disabled
                     }
                   }
                   label="Hasło"
      >

        <PasswordMask data-test='input-password' { ...{ value, onChange, onFocus, onBlur, inputRef } }/>
      </FormControl>
    );
  }
}

LoginFormPasswordContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  validationMessage: PropTypes.string.isRequired,
  markedAsWrong: PropTypes.bool.isRequired,
  apiError: PropTypes.bool.isRequired,
  focus: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};

const mapStateToProps = state => ({
  ...state.loginPasswordReducer
});

export default connect(mapStateToProps)(LoginFormPasswordContainer);
